module.exports = __webpack_public_path__ + "img/switch_thumb.6f5485df.png";